import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddRoleMenuRangeRequest } from '../models/request/roleMenu/AddRoleMenuRangeRequest';

export class RoleMenuService {
    static async getRoleMenusByRoleId(_roleId: string) {
        try {
            var inputObj = {
                roleId: _roleId
            }

            console.log('SERVICE CALL - getRoleMenusByRoleId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/RoleMenu/getRoleMenusByRoleId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addRoleMenuRange(inputObj: AddRoleMenuRangeRequest) {
        try {
            console.log('SERVICE CALL - getRoleMenusByRoleId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/RoleMenu/addRoleMenuRange', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}